import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-28 overflow-hidden" data-id="element-74">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-radial opacity-60 pointer-events-none" data-id="element-75" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-76">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-77">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="flex-1 text-center lg:text-left" data-id="element-78">
            <div className="inline-block px-4 py-1.5 rounded-full border border-gold/30 bg-gold/5 text-gold text-sm font-medium tracking-wide mb-6" data-id="element-79">
              Guía Digital para Compradores Primerizos
            </div>
            <h1 className="font-serif text-5xl lg:text-6xl xl:text-7xl leading-tight mb-6" data-id="element-80">
              Sí Puedes Comprar Casa en USA,{' '}
              <span className="text-gold italic" data-id="element-81">Incluso con ITIN</span>
            </h1>
            <p className="text-muted text-lg lg:text-xl mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-82">
              Descubre cuánto necesitas realmente y cómo empezar paso a paso con
              nuestra guía completa en español.
              </p>

            <div className="flex flex-col items-center lg:items-start gap-6" data-id="element-83">
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 0.8
            }} data-id="element-84">
          <a onClick={() => {
                const element = document.getElementById('cta-descarga');
                if (element) {
                  element.scrollIntoView({
                    behavior: 'smooth'
                  });
                }
              }} className="inline-block bg-gold hover:bg-gold/90 text-charcoal font-semibold text-lg py-4 px-10 rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_20px_rgba(212,165,116,0.4)]" data-id="element-85">
            Descarga tu Guia YA
          </a>
        </motion.div>

              <div className="flex flex-wrap justify-center lg:justify-start gap-4 text-sm text-muted/80" data-id="element-86">
                <div className="flex items-center gap-1.5" data-id="element-87">
                  <Check className="w-4 h-4 text-gold" data-id="element-88" />
                  <span data-id="element-89">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-90">
                  <Check className="w-4 h-4 text-gold" data-id="element-91" />
                  <span data-id="element-92">100% en español</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-93">
                  <Check className="w-4 h-4 text-gold" data-id="element-94" />
                  <span data-id="element-95">Sin tecnicismos</span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex-1 w-full max-w-lg lg:max-w-none relative" data-id="element-96">
            <div className="relative rounded-2xl overflow-hidden border border-gold/20 gold-glow" data-id="element-97">
              <div className="absolute inset-0 bg-gradient-to-t from-dark/80 via-transparent to-transparent z-10" data-id="element-98" />
              <img src="https://cdn.magicpatterns.com/uploads/6W8WKMph59H3oUet5M9P43/a2.jpg" alt="Familia recibiendo las llaves de su nueva casa" className="w-full h-auto object-cover aspect-[4/5] lg:aspect-square" data-id="element-99" />
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 border-b-2 border-l-2 border-gold/30 rounded-bl-xl" data-id="element-100" />
            <div className="absolute -top-6 -right-6 w-24 h-24 border-t-2 border-r-2 border-gold/30 rounded-tr-xl" data-id="element-101" />
          </motion.div>
        </div>
      </div>
    </section>;
}